import React, { useState, useEffect } from "react";
import "./stylesCotizadorProgrammaticFrecuencia.scss";

export const CotizadorProgrammaticFrecuencia = ({
  onFrecuenciaChange,
  isProgrammaticSelected,
  isDigitalSelected,
  selectedOption,
  plazo,
  defaultFrecuencia,
  frecuencia,
  resetCounter,
}) => {
  const [selectedPaquete, setSelectedPaquete] = useState(defaultFrecuencia ? String(defaultFrecuencia) : "");

  // Sincronizar con la prop frecuencia y resetear cuando cambie resetCounter
  useEffect(() => {
    setSelectedPaquete(frecuencia ? String(frecuencia) : ""); // Sincronizar con la prop frecuencia
  }, [frecuencia, resetCounter]);

  useEffect(() => {
    if (defaultFrecuencia) {
      const frequencyAsString = String(defaultFrecuencia);
      setSelectedPaquete(frequencyAsString);
      onFrecuenciaChange(frequencyAsString);
    }
  }, [defaultFrecuencia, onFrecuenciaChange]);

  const handlePaqueteChange = (event) => {
    const value = event.target.value;
    setSelectedPaquete(value);
    onFrecuenciaChange(value);
  };

  const isRecommended = (value) => {
    if (!isProgrammaticSelected && !isDigitalSelected) {
      return false;
    }

    if (plazo === 0) {
      return false;
    }

    if (isProgrammaticSelected || plazo < 5) {
      return ["25", "30"].includes(value);
    }

    if (isDigitalSelected) {
      if (!selectedOption) {
        return false;
      }

      const isFullDay = selectedOption === "FULL DAY | 07:00 - 21:00";
      const isAmOrPm = selectedOption === "AM | 07:00 - 14:00" || selectedOption === "PM | 14:00 - 21:00";

      if (plazo >= 20) {
        if (isFullDay) return value === "5";
        if (isAmOrPm) return value === "10";
      } else if (plazo === 10) {
        if (isFullDay) return value === "10";
        if (isAmOrPm) return value === "15";
      } else if (plazo === 5) {
        if (isFullDay) return value === "15";
        if (isAmOrPm) return value === "20";
      }
    }

    return false;
  };

  return (
    <div className="frecuencia">
      <p className="titulofrecuencia">FRECUENCIA</p>
      <hr />
      <p className="subtitulo">
        SALIDAS POR HORA <br /> POR PANTALLA
      </p>
      <hr />
      <label className="checkboxfrecuencia">
        <input
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          checked={selectedPaquete === "5"}
          name="paquete"
          onChange={handlePaqueteChange}
          type="checkbox"
          value="5"
        />
        5 {isRecommended("5") && "(recomendado)"}
      </label>
      <br />
      <label className="checkboxfrecuencia">
        <input
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          checked={selectedPaquete === "10"}
          name="paquete"
          onChange={handlePaqueteChange}
          type="checkbox"
          value="10"
        />
        10 {isRecommended("10") && "(recomendado)"}
      </label>
      <br />
      <label className="checkboxfrecuencia">
        <input
          checked={selectedPaquete === "15"}
          name="paquete"
          onChange={handlePaqueteChange}
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          type="checkbox"
          value="15"
        />
        15 {isRecommended("15") && "(recomendado)"}
      </label>
      <br />
      <label className="checkboxfrecuencia">
        <input
          checked={selectedPaquete === "20"}
          name="paquete"
          onChange={handlePaqueteChange}
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          type="checkbox"
          value="20"
        />
        20 {isRecommended("20") && "(recomendado)"}
      </label>
      <br />
      <label className="checkboxfrecuencia">
        <input
          checked={selectedPaquete === "25"}
          name="paquete"
          onChange={handlePaqueteChange}
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          type="checkbox"
          value="25"
        />
        25 {isRecommended("25") && "(recomendado)"}
      </label>
      <br />
      <label className="checkboxfrecuencia">
        <input
          checked={selectedPaquete === "30"}
          name="paquete"
          onChange={handlePaqueteChange}
          style={{ width: "15px", height: "15px", marginRight: "10px", alignContent: "center" }}
          type="checkbox"
          value="30"
        />
        30 {isRecommended("30") && "(recomendado)"}
      </label>
      <br />
    </div>
  );
};
